import type { NewsItem } from "@/types/content";

export const newsList: NewsItem[] = [
  {
    id: "news-001",
    title: "年度科幻大剧《长夜星河》收官，开放式结局引发全网热议",
    date: "2024-06-18",
    summary:
      "《长夜星河》迎来大结局，跨越三十年的电台信号终于找到答案。主创团队解读结局留白，观众期待第二季续写星河。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20film%20news%20image%2C%20vintage%20radio%20on%20a%20desk%20under%20starry%20night%20sky%2C%20warm%20amber%20light%20with%20deep%20blue%20background%2C%20cinematic%20moody%20atmosphere%2C%20minimal%20composition&width=800&height=500&seq=miyue-tv-news-01&orientation=landscape",
    category: "剧集动态",
    content:
      "由沈星野执导的年度科幻大剧《长夜星河》正式收官。剧集自开播以来，凭借冷峻克制的科幻设定与细腻真挚的情感表达，收获了口碑与热度的双丰收。\n\n大结局中，主持人周砚终于与三十年后的信号完成最后的对话，一段被时间掩埋的真相浮出水面。主创团队在采访中表示，结局的留白并非遗憾，而是希望把想象的空间还给观众。\n\n片方透露，是否启动第二季将根据观众反馈与剧本打磨进度决定。目前平台已开启重看计划，并上线了幕后特辑与角色纪录片，供观众进一步了解这部作品。",
  },
  {
    id: "news-002",
    title: "《流浪者黎明》释出首支预告，硬核视效登陆暑期档",
    date: "2024-05-30",
    summary:
      "科幻冒险电影《流浪者黎明》发布首支预告，流浪舰队在陌生星球迎来黎明。影片将于暑期档登陆院线。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20space%20scene%2C%20spaceships%20approaching%20an%20alien%20desert%20planet%20at%20dawn%2C%20orange%20sky%20and%20dark%20horizon%2C%20epic%20grand%20scale%2C%20minimal%20editorial%20photo&width=800&height=500&seq=miyue-tv-news-02&orientation=landscape",
    category: "电影资讯",
    content:
      "备受期待的科幻冒险电影《流浪者黎明》今日发布首支正式预告。预告片中，流浪舰队穿越星门，在一颗荒芜星球上迎来了陌生的黎明。\n\n导演沈星野介绍，影片在视效上追求真实质感，团队耗时两年搭建了完整的星球生态与舰队设定，力求让科幻世界可信且动人。\n\n影片由周砚主演，将于暑期档正式登陆院线。片方同时宣布，将推出IMAX与杜比影院版本，为观众带来更具沉浸感的观影体验。",
  },
  {
    id: "news-003",
    title: "刑侦剧《沉默的证词》口碑攀升，法医视角成最大亮点",
    date: "2024-05-12",
    summary:
      "以法医视角切入的刑侦剧《沉默的证词》口碑持续攀升，严谨的推理与克制的叙事获得观众一致好评。",
    cover:
      "https://readdy.ai/api/search-image?query=moody%20crime%20drama%20editorial%20image%2C%20magnifying%20glass%20and%20case%20files%20on%20a%20dark%20desk%2C%20rainy%20window%20bokeh%2C%20teal%20and%20amber%20lighting%2C%20tense%20atmosphere&width=800&height=500&seq=miyue-tv-news-03&orientation=landscape",
    category: "剧集动态",
    content:
      "刑侦剧《沉默的证词》播出过半，评分稳步上升，成为本季度讨论度最高的悬疑作品之一。\n\n与以往刑侦剧不同，本剧以法医的视角切入案件，用严谨的物证推理推动剧情。观众表示，剧中每一份“沉默的证词”都让人印象深刻。\n\n主创团队表示，为还原真实的检验流程，剧组邀请了专业顾问全程参与，力求在细节上经得起推敲。",
  },
  {
    id: "news-004",
    title: "国漫《剑与远方》第二季定档，江湖故事再启程",
    date: "2024-04-25",
    summary:
      "国漫《剑与远方》宣布第二季定档，少年剑客将继续踏上山河之旅，续写侠义与远方的故事。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20ink%20painting%20landscape%2C%20misty%20mountains%20with%20a%20wandering%20swordsman%2C%20warm%20amber%20dusk%20sky%2C%20eastern%20aesthetic%2C%20cinematic%20minimal%20art&width=800&height=500&seq=miyue-tv-news-04&orientation=landscape",
    category: "动漫资讯",
    content:
      "国漫作品《剑与远方》正式宣布第二季定档。延续第一季的江湖世界观，少年剑客将继续踏上寻找断剑的旅程。\n\n制作团队表示，第二季在动作分镜与场景美术上做了全面升级，融入了更多中国山水画的意境表达。\n\n同时，官方公布了全新的主视觉海报与配音阵容，并上线了第一季的回顾专题，供新老观众补番。",
  },
  {
    id: "news-005",
    title: "暑期档观影指南：这几部作品值得走进影院",
    date: "2024-07-02",
    summary:
      "暑期档临近，蜜月TV为你整理本季值得关注的院线作品，从科幻大片到治愈文艺片，总有一部适合你。",
    cover:
      "https://readdy.ai/api/search-image?query=cinema%20editorial%20image%2C%20rows%20of%20empty%20red%20cinema%20seats%20with%20warm%20golden%20lighting%2C%20cozy%20movie%20theater%20atmosphere%2C%20minimal%20cinematic%20composition&width=800&height=500&seq=miyue-tv-news-05&orientation=landscape",
    category: "观影指南",
    content:
      "暑期档是一年中院线作品最集中的时段。蜜月TV整理了一份观影指南，帮助你快速筛选适合自己的作品。\n\n如果你偏爱宏大叙事与震撼视效，《流浪者黎明》是不容错过的选择；若想寻找安静治愈的观影体验，文艺片《风中有座城》会是不错的陪伴。\n\n此外，动画电影与合家欢题材也将陆续上映。建议提前关注排片，选择合适的时间与影厅，获得更好的观影感受。",
  },
  {
    id: "news-006",
    title: "治愈新番《幻梦乐园》完结，观众直呼“舍不得告别”",
    date: "2024-03-20",
    summary:
      "治愈系动画《幻梦乐园》正式完结，温柔的叙事与精美的画面让无数观众直呼舍不得告别。",
    cover:
      "https://readdy.ai/api/search-image?query=dreamy%20anime%20editorial%20image%2C%20glowing%20lanterns%20and%20a%20carousel%20in%20a%20magical%20park%20at%20night%2C%20pastel%20warm%20palette%20with%20golden%20glow%2C%20whimsical%20soft%20atmosphere&width=800&height=500&seq=miyue-tv-news-06&orientation=landscape",
    category: "动漫资讯",
    content:
      "治愈系动画《幻梦乐园》迎来最终话。少女终于找到了回到现实的那扇门，也让无数观众在弹幕中留下“舍不得告别”的感慨。\n\n本作以柔和的色彩与克制的叙事，讲述了关于成长与释怀的故事。许多观众表示，这是一部适合在疲惫夜晚静静观看的作品。\n\n官方宣布，将推出纪念画集与原声专辑，让这份温柔得以延续。",
  },
];